import { render, staticRenderFns } from "./MyButtonRadio.vue?vue&type=template&id=0c5cd6ac&scoped=true&"
import script from "./MyButtonRadio.vue?vue&type=script&lang=js&"
export * from "./MyButtonRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5cd6ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c5cd6ac')) {
      api.createRecord('0c5cd6ac', component.options)
    } else {
      api.reload('0c5cd6ac', component.options)
    }
    module.hot.accept("./MyButtonRadio.vue?vue&type=template&id=0c5cd6ac&scoped=true&", function () {
      api.rerender('0c5cd6ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/commonComponent/MyButtonRadio.vue"
export default component.exports